// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Title-module--cls1--4ErDd","cls2":"styles-Title-module--cls2--1_pX7 styles-Title-module--cls1--4ErDd"};